/** Opening the search hub: which chip, and which project the filter starts on (spec §3). */

/** The hub's filter chips, in the order they show (search hub spec §3). */
export type HubChip =
  | "all"
  | "chats"
  | "notifications"
  | "tasks"
  | "frames"
  | "memory"
  | "settings";

export const HUB_CHIPS: readonly HubChip[] = [
  "all",
  "chats",
  "notifications",
  "tasks",
  "frames",
  "memory",
  "settings",
];

export interface GlobalSearchRequest {
  chip: HubChip;
  /** The project filter's first value; null starts on All projects. */
  projectId: string | null;
  /** Text the search field starts with (the wall's "Search all projects"). */
  query?: string;
}

export const GLOBAL_SEARCH_EVENT = "denker:open-search";

/** A request for a window whose app is not mounted yet is dropped after this long (spec §8). */
export const GLOBAL_SEARCH_REQUEST_TTL_MS = 2000;

let pendingRequest: (GlobalSearchRequest & { requestedAt: number }) | null =
  null;

export function openGlobalSearch(
  request: GlobalSearchRequest,
  now: number = Date.now(),
): void {
  pendingRequest = { ...request, requestedAt: now };
  window.dispatchEvent(
    new CustomEvent<GlobalSearchRequest>(GLOBAL_SEARCH_EVENT, {
      detail: request,
    }),
  );
}

/** The request waiting for this window's app, unless it waited longer than the TTL. */
export function consumeGlobalSearchRequest(
  now: number = Date.now(),
): GlobalSearchRequest | null {
  const request = pendingRequest;
  pendingRequest = null;
  if (!request || now - request.requestedAt > GLOBAL_SEARCH_REQUEST_TTL_MS)
    return null;
  const { requestedAt: _requestedAt, ...waiting } = request;
  return waiting;
}
